/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon24Solid = forwardRef('ArrowDUturnRightUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M23.194 8.724a1.5 1.5 0 1 1-2.188 2.052L18 7.57v5.93a8.5 8.5 0 0 1-17 0v-6a1.5 1.5 0 1 1 3 0v6a5.5 5.5 0 1 0 11 0V7.517l-3.056 3.26a1.5 1.5 0 1 1-2.188-2.053l4.53-4.832a3 3 0 0 1 4.378 0l4.53 4.832Z" })));
});
